export default __webpack_public_path__ + "static/media/featSportBgMb.fc53b805.png";